import { REQUEST_SPENDING_ACCOUNT_BALANCE_REPORT } from './spending-account-balance-report.types';

export const getSpendingAccountBalanceReport = payload => ({
  type: REQUEST_SPENDING_ACCOUNT_BALANCE_REPORT,
  payload,
});
